import { Exclude, Type } from 'class-transformer';
import { KeyValueResultDto } from './key-value-result-dto';
import { Utils } from 'cc-common';

export class PropertyCommunityInfoResultDto {
    communityId: number;
    communityName: string;
    communityStatus: string;
    locationId: number;
    locationName: string;
    managementCompanyId: number;
    managementCompanyName: string;
    customerId: string;
    propertyAddress: string;
    ownerName: string;
    isCurrentOwner: boolean;
    communityCode: string;
    @Type(() => KeyValueResultDto)
    propertyCommunities: Array<KeyValueResultDto>;

    @Type(() => Date)
    terminatingDate: Date;

    get communityTerminatingDate(): Date {
        return this.terminatingDate;
    }

    @Exclude()
    isTerminating = Utils.notNullAndDefined(this.communityTerminatingDate);

    // Transient fields
    get context(): string {
        if (!!this.communityId) {
            return `C${this.communityId}`;
        } else if (!!this.locationId) {
            return `L${this.locationId}`;
        }
        return `M${this.managementCompanyId}`;
    }
}
